export default {
  colors: {
    primary1Color: 'rgb(49, 106, 154)',
    primary2Color: '#0d4f83',
    accent1Color: '#ec6529',
    accent2Color: '#f3f3f3',
    iconColor: '#999',
    iconHoverColor: '#222',
  },
};



// WEBPACK FOOTER //
// ./src/constants/AppConstants.js